<!-- static content data from lang: not_found -->
<template>
<div class="h-100">
<div class="header h-100">
<div class="container h-100">
<div class="header-body text-center h-100">
<div class="row justify-content-center align-items-center h-100">
<div class="col-xl-5 col-lg-6 col-md-8 px-5">
<h1 class="text-light">{{lang.label.title}}</h1>
<p class="text-lead text-white">{{lang.label.message}}</p>
<!-- <b-btn class="font-weight-bold text-white mt-5 btn btn-primary" @click="previousRoute()">{{lang.label.buttons.back}}</b-btn> -->
<base-button type="primary" native-type="submit" class="font-weight-bold text-white mt-5 btn btn-primary" @click="previousRoute()">{{lang.label.buttons.back}}</base-button>
<base-button type="primary" native-type="submit"  class="font-weight-bold text-white mt-5 btn btn-primary" @click="HomeRoute()">{{lang.label.buttons.home}}</base-button>
<!-- <router-link to="/dashboard" class="font-weight-bold text-white mt-5 btn btn-primary">{{lang.label.buttons.home}}</router-link> -->
</div>
</div>
</div>
</div>
</div>
</div>
</template>

<script>
 import {mapGetters} from "vuex";
export default {
name: 'not-found',
data() {
return {
lang: this.$lang.not_found,
}
},
 computed: {
    ...mapGetters({
       type:"type"
    }),
 },
methods :{
  previousRoute(){
   return this.$router.go(-1);
  //  window.location.reload();

      },
  HomeRoute(){

    let type = this.type;
    if(type == 1)
    { // admin
         this.$router.push({name: "companyManagementList"});
          }else if(type == 2){ // company
             this.$router.push({name: "question"});
            }else if(type == 3){ // visitor
                 this.$router.push({name: "myRequest",params:{id:this.login.ID}});
             }else if(type == 4){ // site admin
                 this.$router.push({name: "assignQuestionnaires"});
                              }
  }


}
};
</script>
